var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"policy"},[(_vm.pdfUrl)?_c('pdfShow',{attrs:{"pdfUrl":_vm.pdfUrl}}):_c('p',{staticClass:"policy-empty"},[_vm._v("暂无内容！")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }